import {
	Button,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Grid,
	GridItem,
} from "@chakra-ui/react";
import { format } from "date-fns";

import { formatCurrency } from "@/utils/currency";
import { COLORS, CURRENCY_TO_LOCALE_STRING } from "@/common/constants";
import { InspectorInvoiceByInspectorId } from "@/types/invoiceInspectors.interface";
import { Form, Formik } from "formik";

interface ModalConfirmToPayProps {
	isOpen: boolean;
	onClose: () => void;
	handleConfirmToCancel: () => void;
	handleConfirm: () => Promise<void>;
	dataConfirmation: InspectorInvoiceByInspectorId | undefined;
	handleDownload: (idFile: string, uploadType: number) => Promise<void>;
}

const ModalConfirmToPay = ({
	isOpen,
	onClose,
	handleConfirmToCancel,
	handleConfirm,
	dataConfirmation,
	handleDownload,
}: ModalConfirmToPayProps) => {
	return (
		<Modal onClose={onClose} isOpen={isOpen} isCentered size="xl">
			<ModalOverlay />
			<Formik
				initialValues={{ status: "" }}
				onSubmit={async () => {
					await handleConfirm()
				}}
			>
				{formik => (
					<Form>
			<ModalContent borderRadius={15} padding={"10px"}>
				<ModalHeader>Payment Confirmation</ModalHeader>
				<ModalCloseButton
					onClick={handleConfirmToCancel}
					_focus={{ outline: "none", boxShadow: "none" }}
							/>
				<ModalBody marginTop={5}>
					<Grid templateColumns="repeat(2, 1fr)" gap={6}>
						<GridItem w="100%">
							<p style={{ fontWeight: "bold" }}>Invoice ID</p>
							<p>{dataConfirmation?.invoiceNumber ?? "-"}</p>
							<p style={{ fontWeight: "bold", marginTop: 20 }}>Invoice Date</p>
							<p>
								{dataConfirmation?.invoiceDate
									? format(dataConfirmation?.invoiceDate, "dd-MM-yyyy")
									: "-"}
							</p>
							<p style={{ fontWeight: "bold", marginTop: 20 }}>Vessel Name</p>
							<p>{dataConfirmation?.shipName ?? "-"}</p>
							<p style={{ fontWeight: "bold", marginTop: 20 }}>Amount</p>
							<p>
								{dataConfirmation
									? formatCurrency(
										dataConfirmation.amount,
										dataConfirmation.currency,
										CURRENCY_TO_LOCALE_STRING[dataConfirmation.currency]
									)
									: "-"}
							</p>
						</GridItem>
						<GridItem w="100%" h="10">
							{dataConfirmation?.paymentDownloadId && (
								<Button
												onClick={() =>
													handleDownload(dataConfirmation?.paymentDownloadId, 2)
												}
								>
									Download
								</Button>
							)}
						</GridItem>
					</Grid>
				</ModalBody>
				<ModalFooter
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						gap: 10,
					}}
							>
					<Button
									type="button"
									disabled={formik.isSubmitting}
						onClick={handleConfirmToCancel}
						borderColor="#D0D5DD"
						bgColor="white"
								>
						Cancel
					</Button>
					<Button
									type="submit"
									disabled={formik.isSubmitting}
									isLoading={formik.isSubmitting}
									loadingText="Confirming"
						bgColor={COLORS.BUTTON.BACKGROUND}
						color={COLORS.BUTTON.FOREGROUND}
								>
						Confirm
					</Button>
				</ModalFooter>
			</ModalContent>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default ModalConfirmToPay;
